module.exports = __webpack_public_path__ + "Step1_Header_new.d85a14e1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/mobile/headers/Step1_Header_new.png
// module id = 9Lyw
// module chunks = 0